/* eslint-disable @typescript-eslint/no-unsafe-member-access */
const headers = new Headers();
headers.append('Accept-Language', document.querySelector('html')!.lang);
headers.append('Content-Type', 'application/json');

export const PrimeIncitantService = {
    async pushData(request: any, captchaToken: string) {
        if (request.bankAttestationFile) {
            request.bankAttestationFileName =
                'BankAttestation' +
                getFileExtension(request.bankAttestationFile);
            request.bankAttestationFile = await getFilePromise(
                request.bankAttestationFile
            );
        }

        if (request.employmentContractFile) {
            request.employmentContractFileName =
                'EmploymentContract' +
                getFileExtension(request.employmentContractFile);
            request.employmentContractFile = await getFilePromise(
                request.employmentContractFile
            );
        }

        if (request.trainingInvoiceFile) {
            request.trainingInvoiceFileName =
                'TrainingInvoice' +
                getFileExtension(request.trainingInvoiceFile);
            request.trainingInvoiceFile = await getFilePromise(
                request.trainingInvoiceFile
            );
        }

        if (request.trainingPaymentFile) {
            request.trainingPaymentFileName =
                'TrainingPayment' +
                getFileExtension(request.trainingPaymentFile);
            request.trainingPaymentFile = await getFilePromise(
                request.trainingPaymentFile
            );
        }

        request.workerNiss = request.workerNiss.replace(/[.-]/g, '');

        request.numberCompany = request.numberCompany.replace(/\./g, '');

        request.addressCompany = getAddress(
            request.addressStreet,
            request.addressNumber,
            request.addressPostal,
            request.addressLocality
        );

        request.captchaToken = captchaToken;

        return await fetch('/api/FondsRebond/PushIncitant', {
            method: 'POST',
            body: JSON.stringify(request),
            headers,
        });
    },
};

function getAddress(
    street: string,
    number: string,
    postal: string,
    locality: string
): string {
    return street + ' ' + number + ', ' + postal + ' ' + locality;
}

function getFileExtension(item: File): string {
    return '.' + item.name.split('.').pop();
}

function getFilePromise(file: any): Promise<any> {
    const filePromise = new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as any);
    });

    return filePromise;
}
